import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTermsPost = {
    path: "/terms",
    method: RouteHttpVerb.POST
};
export { locationRestTermsPost };
